import { log } from 'log';
import { usePushSubscription } from 'server';
import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { useSmartClosePopups } from 'js/components/common/PopupManager';

import { showGeofencingPopupAction } from '../actions';
import * as Types from '../types';

export const useOnACLRuleFailure = ({
    sdk,
    nextTime,
    triggerGeolocation,
    setTransactionID,
    setLicense,
    setNextTime,
    setShowOverlay,
    useTransparentPopup
}: {
    sdk: Types.GeofencingSdkInstance | null;
    nextTime: number;
    triggerGeolocation: () => Promise<void>;
    setTransactionID: (transactionID: string | null) => void;
    setLicense: (license: string | null) => void;
    setNextTime: (nextTime: number) => void;
    setShowOverlay: (showOverlay: boolean) => void;
    useTransparentPopup: boolean;
}) => {
    const dispatch = useDispatch();
    const onRefresh = useCallback(() => window.location.reload(), []);
    const closePopups = useSmartClosePopups();

    usePushSubscription(31133, () => async (pushMessage) => {
        if (!sdk) {
            return;
        }

        const { action } = pushMessage.data;
        const actionType = Object.keys(action);

        if (actionType.includes('actionAclRulesFailedInfo')) {
            const { failedAclRuleParameters = [], userError = {} } = action.actionAclRulesFailedInfo ?? {};

            if (!failedAclRuleParameters.includes('GEOLOCATION_VALIDATED')) {
                return;
            }

            const { message } = userError;

            log('gcInfo', { event: 'actionAclRulesFailedInfo' });

            dispatch(showGeofencingPopupAction({
                title: 'playtech.mobile.system.geocomply.popups.error.title',
                content: message,
                isModal: true,
                buttons: [
                    {
                        onClick: () => closePopups(),
                        text: 'playtech.mobile.system.geocomply.popups.error.ignore',
                        color: 'negative'
                    },
                    {
                        onClick: onRefresh,
                        text: 'playtech.mobile.system.geocomply.popups.error.refresh',
                        color: 'info'
                    }
                ],
                useTransparentPopup
            }));

            // unset current timeout
            setTransactionID(null);
            setLicense(null);
            setNextTime(0);
            setShowOverlay(false);

            await triggerGeolocation();
        }
    }, [
        sdk,
        nextTime,
        triggerGeolocation,
        closePopups,
        onRefresh,
        dispatch,
        setTransactionID,
        setLicense,
        setNextTime,
        setShowOverlay,
        useTransparentPopup
    ]);
};
